import { createFormErrorMessage } from '@/components/FormErrorMessage';
import settings from '@/constants/constants';
import { directToDoctorSteps } from '@/data/DirectToDoctor/direct-to-doctor-steps';
import { useD2DTracking } from '@/hooks/useD2DTracking';
import { handleDirectToDoctorAnswersTransform } from '@/pages/DirectToDoctorForms/transformDirectToDoctorAnswers';
import { RoutedFormBuilder } from '@montugroup/form-builder/routing';
import { WithPageWrapper } from '../components/Branding';
import { FormStep } from '../components/Form';

export const DIRECT_TO_DOCTOR_FORM_ID = 'direct-to-doctor-form';
export const DIRECT_TO_DOCTOR_POST_URL = `${settings.xApiUrl}/patient-portal/v1/d2d-pre-consultation-form`;
const DirectToDoctorErrorMessage = createFormErrorMessage({});

export const DirectToDoctorForm = () => {
  const { trackD2dQuestionsStarted, trackD2dQuestionsCompleted } = useD2DTracking();

  return WithPageWrapper(
    <RoutedFormBuilder
      basePath="/direct-to-doctor"
      formId={DIRECT_TO_DOCTOR_FORM_ID}
      postUrl={DIRECT_TO_DOCTOR_POST_URL}
      steps={directToDoctorSteps({ onStart: trackD2dQuestionsStarted })}
      transform={handleDirectToDoctorAnswersTransform}
      afterSubmitSuccess={() => trackD2dQuestionsCompleted()}
      stepButtonsConfig={{ fullWidthStepButtons: true }}
      errorSlot={DirectToDoctorErrorMessage}
      showStepIndicator={({ currentStep, totalSteps }) => (
        <FormStep>
          Question {currentStep} of {totalSteps}
        </FormStep>
      )}
    />,
    true,
  );
};
